import React from "react";
import "./VisitEliteOptix.css";
import { useNavigate } from "react-router-dom";

const VisitEliteOptix = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/contact");
  };
  return (
    <div className="visit-elite">
      <h2 className="visit-title">
        Visit Elite <span>Optix</span>
      </h2>
      <p className="visit-text">
        Experience precision and luxury in every detail. Book your next eye exam today.
      </p>
      <button className="visit-btn" onClick={handleButtonClick}>Book an Eye Exam</button>
    </div>
  );
};

export default VisitEliteOptix;
